const moduloRPlus = {
  agGrid: {
    paginacion: 15,
    id: 'myGridListGaritas',
    class: 'ag-theme-alpine',
    style: {
      width: '100%',
      height: '400px'
    }
  },
  titulos: {
    consultaDeProcesos: {
      titulo: 'Consulta de Procesos',
      modulo: 'RPlus',
      tituloCardListar: 'Listar Consultas de Procesos',
    },
    ejecucionDeProcesos: {
      titulo: 'Ejecución de Procesos',
      modulo: 'RPlus',
      tituloCardListar: 'Listar Ejecución de Procesos'
    },
    //T.14473 CPD Forzado
    configurarProcesos: {
      titulo  : 'Configuración de CPD',
      modulo  : 'RPlus',
      tituloCardListar  : 'Listar Configuraciones',
      tituloAgregar : "Nuevo resgistro",
      tituloActualizar : "Actualizar registro",
    },
  },
  button: {
    buttonsCss: {
      danger: 'btn btn-danger btn-block',
      info: 'btn btn-info btn-block'
    },
    buttonsNombre: {
      //*GLOBAL
      editar: 'Editar',
      eliminar: 'Eliminar',
      nuevo: 'Nuevo',
      ejecutar: 'Ejecutar',
      agregar: 'Agregar',
      imprimir: 'Imprimir',
    }
  },
  mensajes: {
    eliminar: '¿Esta seguro que desea eliminar el siguiente registro?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente registro?',
    datoGuardado: 'Se guardo corectamente..!!',
    completeInformacion: 'Complete la informacion requerida',
    mensajeAdvertencia: 'La Órden contiene un solo elemento en el detalle desea eliminar la órden completa?',
    guardarDatorForm: 'Desea guardar los datos del formulario',
    mjsProcesar: 'Desea procesar los datos del formulario',
    mjsCampo: 'Al menos debe contener otro Campo "Articulo Alternativo"',
    mjsCampo1: 'Al menos debe contener otro Campo "CodigoBarra"',
    mjsCampo2: 'Al menos debe contener otro Campo',
    mjsCampoAdv: 'Obligatorio Campo Cantidad',
    mjsFilasCorrectas: 'Filas Correctas',
    mjsFilasIncorrectas: 'Filas Incorrectas',
    procesar: '¿Esta seguro que desea procesar el siguiente formulario?'
  },
  url: {
    consultaDeProcesos: {
      obtenerTodo: '/history?date=',
    },
    ejecucionDeProcesos: {
      onDemand: '/daily-parts/save-on-demand',
      demandAll: '/api/v2/demand-all',
      partes: '/api/v2/parts',
      inventario: '/api/v2/inventory',
      demandas: '/api/v2/demand-order',
      supply: '/api/v2/supply-order',
      formulas: '/api/v2/demand-history',
      consumos: '/api/v2/bill-of-material',
      import: '/api/v2/import',
    },
    parametros: {
      path: '/parametro-cpd',
    },
  }
}

export {moduloRPlus}
